import { render, staticRenderFns } from "./FormInviter.vue?vue&type=template&id=48db7110"
import script from "./FormInviter.vue?vue&type=script&lang=js"
export * from "./FormInviter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports